module.exports = __webpack_public_path__ + "img/09_3_1_1.2dddf980.png";